export class IdAllocator {
  private nextId: number;

  private freeIds: number[] = [];

  private maxId: number;

  constructor(minId: number, maxId: number) {
    this.nextId = minId;
    this.maxId = maxId;
  }

  allocate() {
    const { freeIds, nextId, maxId } = this;
    if (freeIds.length > 0) {
      return freeIds.pop();
    }
    if (nextId === maxId) {
      return undefined;
    }
    const id = nextId;
    this.nextId += 1;
    return id;
  }

  release(id: number) {
    const { freeIds } = this;
    freeIds.push(id);
  }
}
